
import Vue from 'vue'
import { email, minLength, required, sameAs } from 'vuelidate/lib/validators'
import { userRegister } from '@/connectors/user'
import { ModalIds } from '@/components/popup/modal-ids'

export default Vue.extend({
  name: 'Register',
  data () {
    return {
      ModalIds,
      profile: {
        name: '',
        email: '',
        inn: '',
        phone: '',
        password: '',
        passwordConfirmation: ''
      },
      errorMsg: {}
    }
  },
  methods: {
    register () {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }

      console.log(this.profile, '====')

      this.errorMsg = {}
      userRegister(this.profile)
        .then((res) => {
          console.log('register', res)
          localStorage.setItem('moid', String(res.data.managing_organization.id))
          this.$router.push('/app/managing_organization_wizard')
        }).catch((e) => {
          console.error(e.response)
          if (e.response.status === 403) {
            // @ts-ignore
            this.$showErrorToast(e.response.data.message)
          } else {
            // @ts-ignore
            this.$showErrorToast(e.response.data.message)
          }
        })
    },
    inputState (property): string {
      // @ts-ignore
      if (this.$v.profile[property].$dirty && !this.$v.profile[property].$error) {
        return 'is-valid'
        // @ts-ignore
      } else if (!this.$v.profile[property].$dirty) {
        return ''
      } else return 'is-invalid'
    }
  },
  validations: {
    profile: {
      name: {
        required
      },
      email: {
        required,
        email
      },
      phone: {
        required,
        minLength: minLength(10)
      },
      inn: {
        required,
        validation (val: string) {
          return /^(\d{10}|\d{12})$/.test(val)
        }
      },
      password: {
        required,
        minLength: minLength(6)
      },
      passwordConfirmation: {
        sameAsPassword: sameAs('password'),
        minLength: minLength(6)
      }
    }
  }
})
